export const config = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    { title: '标题', dataIndex: 'title', width: 300, render: 'titleRender' },
    { title: '分类', dataIndex: 'categoryName', width: 200, ellipsis: true },
    { title: '标签', dataIndex: 'contentTags', width: 200, render: 'tagRender' },
    { title: '上架APP', dataIndex: 'appGrounding', width: 100, render: 'appRender' },
    { title: '发布C端', dataIndex: 'cgrounding', width: 100, render: 'cRender' },
    { title: '创建人', dataIndex: 'createByName', width: 100 },
    { title: '创建时间', dataIndex: 'createdTime', width: 180, itemType: 'dateTime' },
    { title: '上架时间', dataIndex: 'appGroundingTime', width: 180, itemType: 'dateTime' },
    { title: '发布时间', dataIndex: 'creleaseTime', width: 180, itemType: 'dateTime' },
    { title: '操作', dataIndex: 'action', width: 120, fixed: 'right', align:'center', render: 'actionRender' },
  ],
  search: [
    { label: '标题', name: 'title' },
    { label: '上架APP', name: 'appGrounding', itemType: 'select', key:'value', data: 'statueEnum' },
    { label: '发布C端', name: 'cgrounding', itemType: 'select', key:'value', data: 'statueEnum' },
    {
      label: '发布范围',
      name: 'type',
      itemType: 'select',
      data: 'visibilityList',
      key: 'value',
      labelKey: 'label',
    },
    { label: '创建人', name: 'createByName' },
    { label: '创建时间', name: 'createdDate', itemType: 'autoDate', showTime:true },
    { label: '上架时间', name: 'appGroundingDate', itemType: 'autoDate', showTime:true },
    { label: '发布时间', name: 'creleaseDate', itemType: 'autoDate', showTime:true },
    {
      label: '排序方式',
      name: 'orderSort',
      itemType: 'select',
      data: 'orderEnum',
      key: 'value',
      labelKey: 'label',
    },
    {
      label: '楼盘',
      name: 'buildingName',
    },
  ],
  footer: [{ label: '新增', type: 'primary', events: ['onClick:onAdd'] }],
  searchInitialValues:{'orderSort':'1'}
}

export const VisibilityList = [
  { label: '全员共享', value: 'all' },
  { label: '门店', value: 'store' },
  { label: '部门', value: 'dept' },
  { label: '仅自己可见', value: 'single' },
]
